"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var AppView_styles_1 = require("./AppView.styles");
var AppView_classNames_1 = require("./AppView.classNames");
var CommandBar_1 = require("office-ui-fabric-react/lib/CommandBar");
var css_1 = require("@uifabric/utilities/lib/css");
var AppView = /** @class */ (function (_super) {
    __extends(AppView, _super);
    function AppView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(AppView.prototype, "hasMenu", {
        get: function () {
            var props = this.props.commandBarProps;
            return props &&
                ((props.items && props.items.length > 0) ||
                    (props.farItems && props.farItems.length > 0));
        },
        enumerable: true,
        configurable: true
    });
    AppView.prototype._renderMenu = function () {
        if (this.hasMenu) {
            return (React.createElement("div", { className: css_1.css(this._classNames.menuContainer, { rootView: this.props.root }) },
                React.createElement(CommandBar_1.CommandBar, __assign({}, this.props.commandBarProps))));
        }
        return null;
    };
    AppView.prototype._renderMain = function () {
        return (React.createElement("div", { role: "main", className: css_1.css(this._classNames.main, { hasMenu: this.hasMenu, rootView: this.props.root }) }, this.props.children));
    };
    AppView.prototype.render = function () {
        this._classNames = AppView_classNames_1.getClassNames(AppView_styles_1.getStyles(null, this.props.styles), this.props.className);
        return (React.createElement("div", { className: css_1.css(this._classNames.root, { rootView: this.props.root }) },
            this._renderMenu(),
            this._renderMain()));
    };
    return AppView;
}(React.Component));
exports.AppView = AppView;
